// extracted by mini-css-extract-plugin
export var content = "richTextCta-module--content--72350";
export var copy = "richTextCta-module--copy--b70ae";
export var link = "richTextCta-module--link--0fc6e";
export var richTextCta = "richTextCta-module--rich-text-cta--ef5e7";